import { CSSProperties } from 'react'

import { BoxProps } from '@chakra-ui/react'

// Pixel-parity carry of the legacy v1 chip (ENG-31544): fixed palette in both
// schemes (white chip, link.100 #3D7FCE hover, #BBB border) — reconcile when
// the rebrand designs a tag chip.
export const buttonTagContainerStyles: BoxProps = {
  _hover: {
    backgroundColor: '#3D7FCE',
    color: 'white',
  },
  alignItems: 'center',
  backgroundColor: 'white',
  color: 'black',
  css: {
    // hover recolors nested event-icon strokes, like the legacy chip
    '&:hover .icon path:not(:first-of-type)': { stroke: 'white' },
  },
  display: 'flex',
  flexDirection: 'row',
  fontSize: '14px',
  fontWeight: '600',
  justifyContent: 'flex-start',
  lineClamp: 1,
}

export const buttonTagButtonBaseStyle: CSSProperties = {
  marginRight: '0px',
  padding: '1px 7px 1px 7px',
  display: 'flex',
  border: '2px solid #BBB',
  borderRadius: '10px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}
